import { api } from 'shared/api'
import { AiToneOfVoiceSchemas } from 'shared/api/requests/aiToneOfVoice/schemas'

export const AiToneOfVoiceApi = {
  initialize: api.account.createPost({
    url: '/ai-service/tone-of-voice/init',
    schemas: AiToneOfVoiceSchemas.initialize,
    scope: 'ai',
    section: 'ai_always_on_automation',
  }),
  getData: api.account.createGet({
    url: '/aiToneOfVoice/getData',
    schemas: AiToneOfVoiceSchemas.getData,
    scope: 'ai',
    section: 'ai_always_on_automation',
  }),
  processFeedback: api.account.createPost({
    url: '/ai-service/tone-of-voice/process-feedback',
    schemas: AiToneOfVoiceSchemas.processFeedback,
    scope: 'ai',
    section: 'ai_always_on_automation',
  }),
}
